var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showMenu)?_c('app-menu'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-fade-transition',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }